import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import UploadCloudIcon from '@fingo/lib/assets/icons/itau/UploadCloudIcon';
import { MAX_FILE_SIZE_MB, NOMINA_ACCEPTED_EXTENSIONS } from '../../constants/upload-nomina';

const UploadNominaDropZoneContent = ({ files }) => {
  const theme = useTheme();
  return (
    <Stack direction="row" justifyContent="center" alignItems="center" spacing={2.875}>
      <UploadCloudIcon
        width={40}
        height={40}
        style={{ flexShrink: 0, color: theme.palette.secondary.main }}
      />
      <Stack spacing={0.25} alignItems="flex-start">
        {files.length ? (
          <Typography variant="medium_2" fontWeight={700} sx={{ color: 'gray.A700' }}>
            {files[0].name}
          </Typography>
        ) : (
          <>
            <Typography variant="medium_2" fontWeight={700} sx={{ color: 'gray.A700' }}>
              Sube o arrastra las nóminas
            </Typography>
            <Typography variant="small_3" sx={{ color: 'gray.A500' }}>
              {`Tamaño máximo de archivo: ${MAX_FILE_SIZE_MB}MB`}
            </Typography>
            <Typography variant="small_3" sx={{ color: 'gray.A500' }}>
              {`Formatos admitidos: ${NOMINA_ACCEPTED_EXTENSIONS}`}
            </Typography>
          </>
        )}
      </Stack>
    </Stack>
  );
};

UploadNominaDropZoneContent.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })).isRequired,
};

export default UploadNominaDropZoneContent;
